import type {
    IProcessActivityReadSection,
    ProcessActivityReadSectionItemType,
} from '@common/interfaces/processActivityReadSection';

export function getAllProcessActivityReadSectionItems(
    readSections: IProcessActivityReadSection[]
): ProcessActivityReadSectionItemType[] {
    return readSections.flatMap((readSection) =>
        readSection.items.concat(readSection.subsections?.flatMap((subsection) => subsection.items) ?? [])
    );
}

// We have to curry the function, because partial type inference is not supported https://stackoverflow.com/a/75777692
export function getProcessActivityReadSectionItem<ReadData extends object>() {
    return <Key extends keyof ReadData>(
        readSections: IProcessActivityReadSection[],
        key: Key
    ): ProcessActivityReadSectionItemType<string, string, ReadData[Key]> | undefined => {
        const readSectionItems = getAllProcessActivityReadSectionItems(readSections);
        const item = readSectionItems.find((sectionItem) => sectionItem.key === key);

        return item as ProcessActivityReadSectionItemType<string, string, ReadData[Key]> | undefined;
    };
}

export function getAllProcessActivityReadSectionItemsOfKey<ReadData extends object>() {
    return <Key extends keyof ReadData>(
        readSections: IProcessActivityReadSection[],
        key: Key
    ): ProcessActivityReadSectionItemType<string, string, ReadData[Key]>[] => {
        const readSectionItems = getAllProcessActivityReadSectionItems(readSections);
        const items = readSectionItems.filter((sectionItem) => sectionItem.key === key);

        return items as ProcessActivityReadSectionItemType<string, string, ReadData[Key]>[];
    };
}
